if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    
    $('.portfolio-images').slick({
        accessibility: false
    });

    $('.portfolio-slides').slick({
        accessibility: false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false,
                  variableWidth: false
                }
              },
        ]
    });

    $(".slider-v").slick({
        accessibility: false,
    });
    
    $(".slider-h").slick({
        accessibility: false,
    });

    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });
    
    // Call Gridder
    $('.gridder').gridderExpander({
        scroll: true,
        scrollTo: "panel", // panel or listitem
        animationSpeed: 400,
        animationEasing: "easeInOutExpo",
        showNav: true, // Show Navigation
        nextText: "Next", // Next button text
        prevText: "Previous", // Previous button text
        closeText: "Close", // Close button text
        onStart: function () {
            //Gridder Inititialized
        },
        onContent: function () {
            //Gridder Content Loaded
        },
        onClosed: function () {
            //Gridder Closed
        }
    });
    
    //filter for team
    const filterteam = document.querySelector('#our-team--filter');
    if (filterteam != null) {
        filterteam.addEventListener("change", function (e) {
            let selectfilter = this.value;
            let items = document.querySelectorAll('.our-team__item');
            let itemfilter = document.querySelectorAll('.our-team__item.' + selectfilter);
            // close gridder
            const closegridder = document.querySelector('a.gridder-close');
            if (closegridder != null) {
                closegridder.click()
            }
            items.forEach((item) => {
                item.classList.add('hidden')
            })

            itemfilter.forEach((itemf) => {
                itemf.classList.remove('hidden')
            })

        });
    }

})();